<div
  *ngIf="withDate && (job?.date || date)"
  class="job-date"
  data-cy="job-date-info">
  {{ job?.date || date | date: "EEEEEE. dd.MM.yyyy" }}
</div>
<ng-container *ngIf="job?.yourself?.partialTimes; else originalTimes">
  <div class="job-shifts">
    <div
      *ngFor="let shift of job?.yourself?.partialTimes"
      class="job-shift"
      data-cy="partial-time">
      <div class="job-shift-tag">
        {{ "shifts." + shift.shift | i18n | titlecase }}
      </div>
      <div class="job-shift-time">
        {{ shift.from | time }} - {{ shift.to | time }}
      </div>
    </div>
  </div>
</ng-container>
<ng-template #originalTimes>
  <div
    class="job-shifts"
    *ngIf="job?.shifts || shifts">
    <div
      *ngFor="let shift of job?.shifts || shifts"
      class="job-shift"
      data-cy="shift-time">
      <div class="job-shift-tag">
        {{
          shift.label
            ? shift.label
            : ("shifts." + shift.shift | i18n | titlecase)
        }}
      </div>
      <div class="job-shift-time">
        {{ shift.from | time }} - {{ shift.to | time }}
      </div>
    </div>
  </div>
</ng-template>
